import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPerforatedSheet = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "100%",
	height: "100%",
	viewBox: "0 0 128 128",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	xmlSpace: "preserve",
	"xmlns:serif": "http://www.serif.com/",
	style: {
		fillRule: "evenodd",
		clipRule: "evenodd",
		strokeLinejoin: "round",
		strokeMiterlimit: 2
	},
	...props,
	children: [
		/* @__PURE__ */ _jsx("g", {
			transform: "matrix(0.746684,0,-0.384377,0.746684,41.5131,14.6702)",
			children: /* @__PURE__ */ _jsx("rect", {
				x: 9.586,
				y: 11.549,
				width: 109.076,
				height: 109.032
			})
		}),
		/* @__PURE__ */ _jsxs("g", {
			transform: "matrix(1,0,0,1,0,-1)",
			children: [
				/* @__PURE__ */ _jsx("circle", {
					cx: 53.056,
					cy: 34.928,
					r: 6.325,
					style: { fill: "white" }
				}),
				/* @__PURE__ */ _jsx("g", {
					transform: "matrix(1,0,0,1,24.7658,0)",
					children: /* @__PURE__ */ _jsx("circle", {
						cx: 53.056,
						cy: 34.928,
						r: 6.325,
						style: { fill: "white" }
					})
				}),
				/* @__PURE__ */ _jsx("g", {
					transform: "matrix(1,0,0,1,49.5316,0)",
					children: /* @__PURE__ */ _jsx("circle", {
						cx: 53.056,
						cy: 34.928,
						r: 6.325,
						style: { fill: "white" }
					})
				})
			]
		}),
		/* @__PURE__ */ _jsxs("g", {
			transform: "matrix(1,0,0,1,2.75116,-1)",
			children: [
				/* @__PURE__ */ _jsx("g", {
					transform: "matrix(1,0,0,1,-33.8418,60.1898)",
					children: /* @__PURE__ */ _jsx("circle", {
						cx: 53.056,
						cy: 34.928,
						r: 6.325,
						style: { fill: "white" }
					})
				}),
				/* @__PURE__ */ _jsx("g", {
					transform: "matrix(1,0,0,1,-9.076,60.1898)",
					children: /* @__PURE__ */ _jsx("circle", {
						cx: 53.056,
						cy: 34.928,
						r: 6.325,
						style: { fill: "white" }
					})
				}),
				/* @__PURE__ */ _jsx("g", {
					transform: "matrix(1,0,0,1,15.6898,60.1898)",
					children: /* @__PURE__ */ _jsx("circle", {
						cx: 53.056,
						cy: 34.928,
						r: 6.325,
						style: { fill: "white" }
					})
				})
			]
		}),
		/* @__PURE__ */ _jsxs("g", {
			transform: "matrix(1,0,0,1,4.11806,-3.68056)",
			children: [
				/* @__PURE__ */ _jsx("g", {
					transform: "matrix(1,0,0,1,-24.7658,42.8071)",
					children: /* @__PURE__ */ _jsx("circle", {
						cx: 53.056,
						cy: 34.928,
						r: 6.325,
						style: { fill: "white" }
					})
				}),
				/* @__PURE__ */ _jsx("g", {
					transform: "matrix(1,0,0,1,-2.13163e-14,42.8071)",
					children: /* @__PURE__ */ _jsx("circle", {
						cx: 53.056,
						cy: 34.928,
						r: 6.325,
						style: { fill: "white" }
					})
				}),
				/* @__PURE__ */ _jsx("g", {
					transform: "matrix(1,0,0,1,24.7658,42.8071)",
					children: /* @__PURE__ */ _jsx("circle", {
						cx: 53.056,
						cy: 34.928,
						r: 6.325,
						style: { fill: "white" }
					})
				})
			]
		}),
		/* @__PURE__ */ _jsxs("g", {
			transform: "matrix(1,0,0,1,2.76698,-2.13889)",
			children: [
				/* @__PURE__ */ _jsx("g", {
					transform: "matrix(1,0,0,1,-13.1501,21.2022)",
					children: /* @__PURE__ */ _jsx("circle", {
						cx: 53.056,
						cy: 34.928,
						r: 6.325,
						style: { fill: "white" }
					})
				}),
				/* @__PURE__ */ _jsx("g", {
					transform: "matrix(1,0,0,1,11.6157,21.2022)",
					children: /* @__PURE__ */ _jsx("circle", {
						cx: 53.056,
						cy: 34.928,
						r: 6.325,
						style: { fill: "white" }
					})
				}),
				/* @__PURE__ */ _jsx("g", {
					transform: "matrix(1,0,0,1,36.3816,21.2022)",
					children: /* @__PURE__ */ _jsx("circle", {
						cx: 53.056,
						cy: 34.928,
						r: 6.325,
						style: { fill: "white" }
					})
				})
			]
		})
	]
});
export default SvgPerforatedSheet;
